import styled from 'styled-components';

const ButtonLink = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
  color: ${props => props.theme.a.color};
  font-weight: bold;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export default ButtonLink;
